<p class="onboarding-header__title">{{ title }}</p>
<p class="onboarding-header__subtitle">{{ subtitle }}</p>
